import { defineComponent as _defineComponent } from 'vue'
import { nativeToNewWeb } from '@/uitls/native';
import { ref } from 'vue';
import router from "@/router";
import { onMounted } from 'vue';
import { noticeConfig } from '@/api/php/home';
import { onUnmounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  name: 'Ann',
  setup(__props, { expose }) {
  expose();

const annOk = require(`@/assets/${process.env.VUE_APP_NAME}/iknowit.png`);
const annClose = require("@/assets/images/url_list_close.png");
const ic_ann = require(`@/assets/${process.env.VUE_APP_NAME}/ic_ann.png`);
const showAnn = ref(false);
const annnotice = ref('');
const intervaltime = ref();
const areadyShow = ref(false);


onMounted(() => {
    getAnnConfig();
    intervaltime.value = setInterval(() => {
        getAnnConfig();
    }, 30 * 1000);
});

onUnmounted(() => {
    cleartime();
})

const cleartime = () => {
    if (intervaltime.value) {
        clearInterval(intervaltime.value);
    }
}

const getAnnConfig = async () => {
    let res: any = await noticeConfig();
    if (res.code == 200) {
        if (res.data.notice_open == 2) {
            if (!areadyShow.value) {
                showAnn.value = true;
                annnotice.value = res.data.notice_pre_content;
                areadyShow.value = true;
            }
        } else if (res.data.notice_open == 3) {
            showAnn.value = false;
            nativeToNewWeb(router, '/ann');
        } else {
            showAnn.value = false;
        }
    }
}

const close = () => {
    showAnn.value = false;
}


const __returned__ = { annOk, annClose, ic_ann, showAnn, annnotice, intervaltime, areadyShow, cleartime, getAnnConfig, close }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})